import { EQUITY_MARKET_SEGMENTS, SCRIP_INSTRUMENTS } from '../../scripDetail';

export const POPULAR_OPTION_CHAIN_OPTIONS = [
  {
   id: '1_26009',
   token: 26009,
   segment_id: 1,
   segment: EQUITY_MARKET_SEGMENTS.NSE_EQ,
   instrument: SCRIP_INSTRUMENTS.OPTION_INDEX,
   display_name: 'BANKNIFTY',
   rank: 1,
   dataAid: 'banknifty',
  },
  {
   id: '1_26000',
   token: 26000,
   segment_id: 1,
   segment: EQUITY_MARKET_SEGMENTS.NSE_EQ,
   instrument: SCRIP_INSTRUMENTS.OPTION_INDEX,
   display_name: 'NIFTY 50',
   rank: 2,
   dataAid: 'nifty50',
  },
  {
   id: '1_26037',
   token: 26037,
   segment_id: 1,
   segment: EQUITY_MARKET_SEGMENTS.NSE_EQ,
   instrument: SCRIP_INSTRUMENTS.OPTION_INDEX,
   display_name: 'FINNIFTY',
   rank: 3,
   dataAid: 'finnifty'
  },
  {
   id: '13_1',
   token: 1,
   segment_id: 13,
   segment: EQUITY_MARKET_SEGMENTS.NSE_CUR,
   instrument: SCRIP_INSTRUMENTS.OPTIONS_CURRENCY,
   display_name: 'USDINR',
   rank: 4,
   dataAid: 'usdinr',
  }
]

export const OPTION_CHAIN_INITIAL_LIST_SIZE = 20;
